import service from '../utils/request';

// 获取交易记录分页列表
export const getTransactionRecordList = (params) => {
  return service.get('/transaction-records/list', { params });
}; 